import React from 'react';
import Poll from "../../../components/pages/grid/Poll/Poll";

const PollGridPage = () => {
    return <Poll/>;
};

export default PollGridPage;